/**
 * Inventory icon vocabulary — one meaning, one icon, one place to change it.
 *
 * Keys are semantic (what the icon means), not visual, so a swap is a one-line edit
 * here rather than a grep across the module. All values are @mui/icons-material
 * components, matching the rest of the codebase.
 */
import BarChartIcon from '@mui/icons-material/BarChart';
import BuildIcon from '@mui/icons-material/Build';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import CancelIcon from '@mui/icons-material/Cancel';
import CategoryIcon from '@mui/icons-material/Category';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClassIcon from '@mui/icons-material/Class';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import FilterListIcon from '@mui/icons-material/FilterList';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import InventoryIcon from '@mui/icons-material/Inventory';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import LabelIcon from '@mui/icons-material/Label';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LockIcon from '@mui/icons-material/Lock';
import MedicationIcon from '@mui/icons-material/Medication';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import NotificationsIcon from '@mui/icons-material/Notifications';
import OutboxIcon from '@mui/icons-material/Outbox';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PeopleIcon from '@mui/icons-material/People';
import PercentIcon from '@mui/icons-material/Percent';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PlaceIcon from '@mui/icons-material/Place';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import ScienceIcon from '@mui/icons-material/Science';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import StoreIcon from '@mui/icons-material/Store';
import StorefrontIcon from '@mui/icons-material/Storefront';
import StraightenIcon from '@mui/icons-material/Straighten';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import TuneIcon from '@mui/icons-material/Tune';
import UploadIcon from '@mui/icons-material/Upload';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export const INV_ICONS = {
  // Modules
  overview: DashboardIcon,
  inventory: WarehouseIcon,
  material: Inventory2Icon,
  pharmacy: LocalPharmacyIcon,
  laboratory: ScienceIcon,

  // Stock operations
  storeQueues: PendingActionsIcon,
  requisitions: AssignmentIcon,
  issues: OutboxIcon,
  returns: KeyboardReturnIcon,
  consumptions: RemoveShoppingCartIcon,
  consolidations: MergeTypeIcon,

  // Stock control
  stores: StoreIcon,
  balances: InventoryIcon,
  openingStock: PlaylistAddIcon,
  transfer: SwapHorizIcon,
  adjustments: TuneIcon,
  goodsDiscard: DeleteSweepIcon,

  // Trace & audit
  ledger: MenuBookIcon,
  batchTrace: SearchIcon,

  // Material masters
  materialGroups: CategoryIcon,
  categories: LabelIcon,
  itemClasses: ClassIcon,
  uoms: StraightenIcon,
  taxMaster: PercentIcon,
  items: Inventory2Icon,
  vendors: PeopleIcon,

  // Procurement
  rfqs: RequestQuoteIcon,
  workOrders: BuildIcon,
  purchaseOrders: ReceiptLongIcon,
  grns: MoveToInboxIcon,
  rejectedItems: ReportProblemIcon,
  vendorReturns: AssignmentReturnIcon,
  purchaseInvoices: DescriptionIcon,
  shipping: LocalShippingIcon,

  // Pharmacy
  activeDispenses: LocalPharmacyIcon,
  controlledQueue: LockIcon,
  directDispenses: StorefrontIcon,
  opdDispenses: AssignmentIndIcon,
  bills: ReceiptIcon,
  refunds: CurrencyExchangeIcon,
  wardReturns: AssignmentReturnIcon,
  preAuth: VerifiedUserIcon,
  medicine: MedicationIcon,

  // Stock signals
  expiry: EventBusyIcon,
  lowStock: WarningAmberIcon,
  outOfStock: CancelIcon,
  available: CheckCircleIcon,

  // Generic actions
  search: SearchIcon,
  filter: FilterListIcon,
  refresh: RefreshIcon,
  exportData: DownloadIcon,
  importData: UploadIcon,
  settings: SettingsIcon,
  reports: BarChartIcon,
  analytics: InsertChartIcon,

  // Entities
  user: PersonIcon,
  users: PeopleIcon,
  patient: PersonOutlineIcon,
  hospital: LocalHospitalIcon,
  location: PlaceIcon,
  notifications: NotificationsIcon,
  payments: CreditCardIcon,
  billing: ReceiptLongIcon,
  security: VerifiedUserIcon,
};

export default INV_ICONS;
